import { IPromise } from 'angular';
import * as _ from 'underscore';

import { getCommonDatasourceInfo } from '../../app/spaces/CommonDatasourceInfo';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IContentInfo } from '../models/IContentInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { DataSources } from '../../content/resources/Datasources';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { openReactAlertDialog } from '../../commonInfra/dialogs/ReactAlertDialog';
import { Messages } from '../../codegen/Localize';

export class ChangeContentTagsAction implements IChangeContentTagsAction {

  public execute: (items: IContentInfo[], actionContext: IActionContext) => IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService', '$translate', 'ModalService'];

  constructor(
    ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
  ) {

    this.execute = ChangeTagsActionHelper.createExecuteFnForMixedContent({
      getDescription: (items: INamedItemInfo[]) => this.getDescription(items),
    });
  }

  private getDescription(items: INamedItemInfo[]) {
    return (items.length === 1)
      ? this.$translate.instant('changeTagsContentDescription', { NAME: L10n.elideIfLong(items[0].name) })
      : this.$translate.instant('changeTagsPluralContentDescription', { COUNT: items.length }, L10n.Interpolations.Count);
  }

  public showChangeTagsForMixedContentDialog(content: IContentInfo[], actionContext: IActionContext) {
    if (this.allContentIsEmbeddedDatasources(content)) {
      return openReactAlertDialog({
        title: Messages.changeTagsDatasource_cannotTagAlertTitle(),
        message: Messages.changeTagsDatasource_cannotTagAlertMessage()
      }).result;
    }

    return this.execute(content, actionContext);
  }

  private allContentIsEmbeddedDatasources(allContent: IContentInfo[]): allContent is IContentInfo<'datasource'>[] {
    return _.all(allContent, item =>
      item.contentType === 'datasource' && DataSources.isEmbedded(getCommonDatasourceInfo(item))
    );
  }
}

Module.instance().service('ChangeContentTagsAction', ChangeContentTagsAction);
